<div class="mpp-blockquote__text" *ngIf="!contentRef" [innerHTML]="content"></div>

<div class="mpp-blockquote__text" *ngIf="contentRef">
  <ng-container *ngTemplateOutlet="contentRef"></ng-container>
</div>
